import { Component, Injectable, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { NewLicenseService } from '../../../../api-services/new-license.service';
import { NIPRFeeResponse } from '../../../../models/license-renewal/feeNIPRResponse';
import { EstimatedCostError } from '../../../../shared/constant';
import { RoleService } from '../../../../services/role.service';

@Component({
  selector: 'app-estimated-cost-popup',
  templateUrl: './estimated-cost-popup.component.html',
  styleUrls: ['./estimated-cost-popup.component.css']
})
export class EstimatedCostPopupComponent implements OnInit {


  isCollapsed: { [index: number]: boolean } = {};
  newLicenseRequestDetails: any;
  subscription: Subscription[] = [];
  LicenseList: any[] = [];
  errorMessage: string = EstimatedCostError.Error;
  RequestedLicenseClassList: any[] = [];
  sortDirection: 'asc' | 'desc' = 'asc';
  isIndividualUser: boolean = false;
  constructor(public activeModal: NgbActiveModal, private newLicenseService: NewLicenseService, private roleService: RoleService ) {
  }

  ngOnInit(): void {
    this.isIndividualUser = this.roleService.isIndividualUser;
    this.subscription.push(this.newLicenseService.newLicenseRequest.subscribe(obj => {

      this.newLicenseRequestDetails = obj;
      this.addStateFeesToSelectedLicenses(this.newLicenseRequestDetails.selectedLoaForNewLicense, this.newLicenseRequestDetails?.estimatedCost);
    }));
  }

  // onSortClick(event: Event, colName){

  // }

  close(): void {
    this.activeModal.close();
  }

  toggleCollapse(event: Event, index: number): void { 
    event.stopPropagation();
    this.isCollapsed[index] = !this.isCollapsed[index];
  }
  ngOnDestroy(): void {
    this.subscription.forEach(t => { t.unsubscribe() })
  }
  addStateFeesToSelectedLicenses(
    selectedLoaForNewLicense: any[],
    estimatedCost: NIPRFeeResponse
  ) {
    if (
      !estimatedCost?.requestedFees?.requestedLicenseFee ||
      !Array.isArray(selectedLoaForNewLicense)
    ) {
      return;
    }

    const licenseFees = estimatedCost.requestedFees.requestedLicenseFee;

    selectedLoaForNewLicense.forEach((stateObj) => {
      const stateCode = stateObj.stateCode;
     
      stateObj.licenseByState.forEach((license) => {
        const licenseClassCode = license.licenseClassCode;
       
        // Find matching fee object
        const matchedFee = licenseFees.find((fee) => {
          const req = fee.rewquestedLicense;
          return (
            req.state === stateCode &&
            req.licenseClassCode === licenseClassCode
          );
        });

        if (matchedFee && matchedFee.stateLicenseFee) {
          // Add fee details to license
          const loaNames: string[] = [];
          const checkedLoas = license.loAsByLicense
            ?.filter((loa: any) => loa.isChecked)
            ?.map((loa: any) => loa.name);
          if (checkedLoas?.length) {
            loaNames.push(...checkedLoas);
          }
          let obj = {
            stateName: stateObj.stateName,
            lisenseClass: license.licenseClassDescription,
            loa: loaNames.join(', '),
            hasError: false,
            stateFee: matchedFee.stateLicenseFee.stateFee,
            stateLateFee: matchedFee.stateLicenseFee.stateLateFee,
            stateOtherFee: matchedFee.stateLicenseFee.stateOtherFee,
            processingFee: matchedFee.stateLicenseFee.processingFee,
            transactionFee: matchedFee.stateLicenseFee.transactionFee,
            stateTotalFee: matchedFee.stateLicenseFee.totalFee,
            feeDescription: matchedFee.stateLicenseFee.feeDescription,
            platformFee: matchedFee.stateLicenseFee.platformFee,
          };
          this.RequestedLicenseClassList.push(obj);
        } 
      });
    });
  }
  assignTotalStateLicenseFeeToStateObj(
    selectedLoaForNewLicense: any[],
    estimatedCost: NIPRFeeResponse
  ) {
    if (
      !Array.isArray(selectedLoaForNewLicense) ||
      !estimatedCost?.requestedFees?.requestedLicenseFee
    ) return;

    const licenseFees = estimatedCost.requestedFees.requestedLicenseFee;

    selectedLoaForNewLicense.forEach((stateObj) => {
      const stateCode = stateObj.stateCode;

      // Filter all fee entries for this state
      const feesForState = licenseFees.filter(
        (fee) => fee.rewquestedLicense?.state === stateCode
      );

      // Sum all fees for this state
      const totalFee = {
        stateFee: 0,
        stateLateFee: 0,
        stateOtherFee: 0,
        processingFee: 0,
        transactionFee: 0,
        stateTotalFee: 0,
        feeDescription: '',
        platformFee: 0,
      };

      feesForState.forEach((fee) => {
        const f = fee.stateLicenseFee;
        if (f) {
          totalFee.stateFee += f.stateFee || 0;
          totalFee.stateLateFee += f.stateLateFee || 0;
          totalFee.stateOtherFee += f.stateOtherFee || 0;
          totalFee.processingFee += f.processingFee || 0;
          totalFee.transactionFee += f.transactionFee || 0;
          totalFee.stateTotalFee += f.totalFee || 0;
          if (this.isIndividualUser) {
            totalFee.platformFee += f?.platformFee || 0;
            totalFee.feeDescription = f?.feeDescription || '';
          }
        }
      });

      // Assign aggregated fee object to the state
      stateObj.stateLicenseFee = totalFee;
      // Combine license class descriptions
      stateObj.licenseClassNames = stateObj.licenseByState
        ?.map((license: any) => license.licenseClassDescription)
        ?.filter(desc => !!desc)
        ?.join(', ') || '';

      // Combine all LOA names that are checked
      const loaNames: string[] = [];
      stateObj.licenseByState?.forEach((license: any) => {
        const checkedLoas = license.loAsByLicense
          ?.filter((loa: any) => loa.isChecked)
          ?.map((loa: any) => loa.name);
        if (checkedLoas?.length) {
          loaNames.push(...checkedLoas);
        }
      });

      stateObj.loaNames = loaNames.join(', ');
    });
  }
  onSortClick(event: Event, column: string): void {
    event.stopPropagation();

    if (column === 'state') {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';

      this.RequestedLicenseClassList.sort((a, b) => {
        const nameA = a.stateName.toLowerCase();
        const nameB = b.stateName.toLowerCase();

        if (nameA < nameB) return this.sortDirection === 'asc' ? -1 : 1;
        if (nameA > nameB) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }
  }
}
